import Papa from 'papaparse';
import {
  formatMarkForComplete,
  forceExcelText, // <-- Importamos esta función
} from '../../../utils/meetUtils';

export function exportFull({
  inscripciones,
  competitionName,
  competitionId = '',
  delimiter = ',',
  forceQuoted = false,
}) {
  // Asegurarnos de que sea un array
  if (!Array.isArray(inscripciones)) {
    console.warn('Inscripciones no es un array. Se usará array vacío.');
    inscripciones = [];
  }

  // 1. Calcular máximos
  const maxTests = inscripciones.reduce((max, insc) => {
    const count = insc.pruebasData ? insc.pruebasData.length : 0;
    return Math.max(max, count);
  }, 0);

  const maxRelays = inscripciones.reduce((max, insc) => {
    const count = insc.relevosData ? insc.relevosData.length : 0;
    return Math.max(max, count);
  }, 0);

  const maxIntegrantes = inscripciones.reduce((max, insc) => {
    if (insc.relevosData) {
      const localMax = Math.max(
        ...insc.relevosData.map((rel) =>
          rel.integrantes ? rel.integrantes.length : 0
        )
      );
      return Math.max(max, localMax);
    }
    return max;
  }, 0);

  const maxSuplentes = inscripciones.reduce((max, insc) => {
    if (insc.relevosData) {
      const localMax = Math.max(
        ...insc.relevosData.map((rel) =>
          rel.suplentes ? rel.suplentes.length : 0
        )
      );
      return Math.max(max, localMax);
    }
    return max;
  }, 0);

  // 2. Encabezado
  const header = [
    'CompetitionID',
    'CompetitionName',
    'CodigoInscripcion',
    'Nombre',
    'Apellido',
    'Email',
    'Teléfono',
    'Rama',
    'Categoría',
    'CatNumber',
    'Dirección',
    'Ciudad',
    'Estado',
    'País',
    'FechaRegistro',
    'PaymentMethod',
    'Asociacion',
    'DiaNacimiento',
    'MesNacimiento',
    'AnioNacimiento',
    'FotoPerfil',
    'LogoEquipo',
    'EquipoNombre',
    'EquipoTeamCode',
    'ContactoNombre',
    'ContactoTeléfono',
    'TutorNombre',
    'TutorEmail',
    'TutorTeléfono',
  ];

  // Agregar columnas dinámicas para pruebas
  for (let i = 1; i <= maxTests; i++) {
    header.push(`Prueba ${i}`, `Marca ${i}`);
  }
  // Agregar columnas dinámicas para relevos
  // Incluimos una columna adicional para la marca de siembra del relevo
  for (let j = 1; j <= maxRelays; j++) {
    header.push(
      `Relevo ${j} Prueba`,
      `Relevo ${j} EquipoTipo`,
      `Relevo ${j} MarcaSiembra`
    );
    for (let k = 1; k <= maxIntegrantes; k++) {
      header.push(`Relevo ${j} Integrante ${k}`);
    }
    for (let k = 1; k <= maxSuplentes; k++) {
      header.push(`Relevo ${j} Suplente ${k}`);
    }
  }

  // 3. Datos
  const csvData = [header];

  inscripciones.forEach((insc) => {
    const row = [];
    row.push(competitionId);
    row.push(competitionName);
    row.push(insc.codigoId || '');
    row.push(insc.nombre || '');
    row.push(insc.apellido || '');
    row.push(insc.email || '');
    row.push(insc.telefono || '');
    row.push(insc.rama || '');
    row.push(insc.categoria || '');
    row.push(insc.catNumber ?? '');

    // Direcciones, etc. sin comas
    const safeAddress = (insc.direccion || '').replace(/,/g, ' ');
    const safeCity = (insc.ciudad || '').replace(/,/g, ' ');
    const safeState = (insc.estado || '').replace(/,/g, ' ');
    const safeCountry = (insc.pais || '').replace(/,/g, ' ');

    row.push(safeAddress);
    row.push(safeCity);
    row.push(safeState);
    row.push(safeCountry);

    row.push(insc.fechaRegistro || '');
    row.push(insc.paymentMethod || '');
    row.push(insc.asociacion || '');
    row.push(insc.diaNacimiento ?? '');
    row.push(insc.mesNacimiento ?? '');
    row.push(insc.anioNacimiento ?? '');

    // Forzamos vacíos para foto y logo
    row.push('');
    row.push('');

    // Equipo
    if (insc.equipo && typeof insc.equipo === 'object') {
      row.push(insc.equipo.name || '');
      row.push(insc.equipo.teamCode || '');
    } else if (typeof insc.equipo === 'string') {
      row.push(insc.equipo);
      row.push('');
    } else {
      row.push('');
      row.push('');
    }

    // Contacto de emergencia
    if (
      Array.isArray(insc.contactoEmergencia) &&
      insc.contactoEmergencia.length > 0
    ) {
      row.push(insc.contactoEmergencia[0].nombreEmergencia || '');
      row.push(insc.contactoEmergencia[0].telefonoEmergencia || '');
    } else {
      row.push('');
      row.push('');
    }

    // Tutor
    row.push(insc.tutorNombre || '');
    row.push(insc.tutorEmail || '');
    row.push(insc.tutorTelefono || '');

    // Pruebas
    for (let i = 0; i < maxTests; i++) {
      const prueba = insc.pruebasData?.[i];
      if (prueba) {
        // Nombre de la prueba
        row.push(prueba.prueba || '');
        // Marca forzada como texto si forceQuoted es true
        const marcaPrueba = formatMarkForComplete(prueba);
        row.push(forceExcelText(marcaPrueba, forceQuoted));
      } else {
        row.push('');
        row.push('');
      }
    }

    // Relevos
    for (let j = 0; j < maxRelays; j++) {
      const relevo = insc.relevosData?.[j];
      if (relevo) {
        // Nombre de la prueba y equipoTipo
        row.push(relevo.prueba || '');
        row.push(relevo.equipoTipo || '');
        // Marca siembra forzada como texto
        const marcaRelevo = formatMarkForComplete(relevo);
        row.push(forceExcelText(marcaRelevo, forceQuoted));

        // Integrantes
        for (let k = 0; k < maxIntegrantes; k++) {
          row.push(relevo.integrantes?.[k] ?? '');
        }
        // Suplentes
        for (let k = 0; k < maxSuplentes; k++) {
          row.push(relevo.suplentes?.[k] ?? '');
        }
      } else {
        row.push('');
        row.push('');
        row.push(''); // Marca siembra vacía
        for (let k = 0; k < maxIntegrantes; k++) {
          row.push('');
        }
        for (let k = 0; k < maxSuplentes; k++) {
          row.push('');
        }
      }
    }

    csvData.push(row);
  });

  // 4. Generar CSV con papaparse
  let csv = Papa.unparse(csvData, {
    quotes: false, // si true, forzamos comillas en todos los campos
    header: true,
    delimiter,
  });

  // Agregar BOM
  const csvWithBOM = '\ufeff' + csv;

  // 5. Descargar
  const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.setAttribute(
    'download',
    `${competitionName || 'Competencia'}_inscritos_completa.csv`
  );
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(url);
}